import { Injectable } from '@angular/core';
import { AppState } from '@shared/app-state';
import { BagCountService } from './../bag-count.service';
import { MathEnum } from '@infrastructure/math-state-enum';
import { OrderService } from '@services/order.service';
import { AddOrderItemExceptionModel } from '@models/add-order-item-exception-model';
import { OrderOnBehalfService } from '@services/order-on-behalf.service';

@Injectable({
  providedIn: 'root'
})
export class BagExecutionService {
  constructor(
    private appState: AppState,
    private bagCountService: BagCountService,
    private orderService: OrderService,
    private orderOnBehalfService: OrderOnBehalfService
  ) {
    this.appState.hasActiveAddToBagExecutionsStatus.subscribe(value => {
      // If there are no active add-to-bag executions - go ahead and update the bag count from the backend
      if (!value) {
        this.orderOnBehalfService.getCustomerOrUserNo().then((customerOrUserNo) => {
          // If a customer or user number is retrieved and there are still no active add-to-bag executions - update the bag count from the backend
          if (customerOrUserNo && !this.appState.hasActiveAddToBagExecutionsStatus.getValue()) {
            this.bagCountService.countUpdateFromBackend(customerOrUserNo);
          }
        });
      }
    });
  }

  /**
   * Runs an add-to-bag action while the header shows the bag spinner.
   * The badge count is refreshed from the server when the last execution finishes.
   * @param action - The action to be executed.
   * @param onSuccess - Optional callback to be executed on success.
   * @param onError - Optional callback to be executed on error.
   */
  public async executeWithBagHandling(
    action: () => Promise<void>,
    onSuccess?: () => void,
    onError?: (error: any) => void
  ): Promise<void> {

    this.appState.concurrentAddToBagExecutions(MathEnum.Addition);

    await action()
      .then(async () => {
        this.appState.concurrentAddToBagExecutions(MathEnum.Substraction);

        if (onSuccess) {
          onSuccess();
        }
      })
      .catch(error => {
        if (error instanceof AddOrderItemExceptionModel) {
          console.error('Error executing add to bag.', error.reason, error.variantString);
          this.appState.addBagError(error.variantString);
        } else {
          console.error('Error executing add to bag:', error);
          this.appState.addBagError('Error adding item to bag');
        }

        // Clearing the in-progress flag refreshes the badge from the server.
        this.appState.ResetActiveAddToBagExecutionsCount();

        if (onError) {
          onError(error);
        }
      });
  }
}
